'use client';

import { useEffect, useRef } from 'react';

import { pushGtmEvent, type GtmEventPayload } from '@/lib/analytics/gtm';
import type { GtmEventName } from '@/lib/analytics/gtmEvents';

interface GtmEventOnMountProps {
  event: GtmEventName;
  payload?: GtmEventPayload;
}

export function GtmEventOnMount({ event, payload }: GtmEventOnMountProps) {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    pushGtmEvent(event, payload);
  }, [event, payload]);

  return null;
}
